var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TMessage',{attrs:{"content":"Top products","size":"h4"}}),_c('div',{staticClass:"v-line mb-4"}),_c('CRow',{staticClass:"mb-4"},[_c('CCol',[_c('Products',{attrs:{"store":"tomoni_products"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }